import { GridColDef } from "@mui/x-data-grid-pro";
import {
  GKClientDataGrid,
  Grid2,
  StatusField,
  Tooltip,
  Typography,
} from "components";
import { useFetchQuery } from "hooks/useQueries";
import DashboardLayout from "layouts/DashboardLayout";
import { useParams } from "react-router-dom";
import { extraColumnsField, matchDate } from "utils/helpers";

const Telegram = () => {
  const { id } = useParams();

  const { data, isLoading } = useFetchQuery({
    key: ["ALL_TELEGRAM_MEMBERSHIPS"],
    route: `/telegram-memberships/?basket_id=${id}`,
  });

  const columns: GridColDef[] = [
    {
      headerName: "Client Name",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 250,
      field: "name",
      renderCell: (params) => {
        return (
          <Tooltip title={params?.row?.name}>
            <Grid2 size={11}>
              <Typography
                fontWeight={700}
                maxWidth={"100%"}
                textOverflow={"ellipsis"}
                overflow={"hidden"}
              >
                {params?.row?.clientName}
              </Typography>
              <Typography fontSize={12}>
                {params?.row?.portfolioName} - {params?.row?.portfolioCode}
              </Typography>
            </Grid2>
          </Tooltip>
        );
      },
    },
    {
      ...extraColumnsField(
        "Telegram Channel Name",
        "advisorChannelName",
        120,
        1,
      ),
    },
    {
      ...extraColumnsField("Telegram User Name", "telegramUsername", 120, 1),
    },
    {
      ...extraColumnsField("Telegram User ID", "telegramUserId", 120, 1),
    },
    {
      ...extraColumnsField("Joining Date", "joinedAt", 120, 1),
      valueFormatter: (params) => matchDate(params?.value),
    },
    {
      ...extraColumnsField("Subscription Status", "isActive", 120, 1),
      renderCell: (row) => (
        <StatusField statusString={row?.row?.isActive.toString()} />
      ),
    },
  ];
  return (
    <DashboardLayout title="Integration Telegram">
      <GKClientDataGrid
        name="telegram"
        loading={isLoading}
        columns={columns}
        rows={data?.data?.data || []}
      />
    </DashboardLayout>
  );
};

export default Telegram;
